import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import SelectCountryOptions from './SelectOption'; 

class SelectCountry extends React.Component {
    static propTypes = {
        selected: PropTypes.string,
        data: PropTypes.arrayOf(PropTypes.object),
        updateFilter: PropTypes.func.isRequired
    };

    static defaultProps = {
        data: [],
        selected: ''
    };

    render() {
        const options = this.props.data.map(
            item => ({ value: item.code, label: item.name })
        );

        return (
            <div className="select select--medal">
                <Select
                    placeholder={'Выберите страну'}
                    name="medal__country_select"
                    value={this.props.selected === '' ? 0 : this.props.selected}
                    optionComponent={SelectCountryOptions}
                    onChange={this.props.updateFilter}
                    options={options}
                />
            </div>
        );
    }
}


export default SelectCountry;



// WEBPACK FOOTER //
// ./src/components/Medals/Select.jsx